<template>
  <ModalProvider id="modalCrearEtiqueta" ref="modalCrearEtiqueta" :is-form="false">
    <template #title>
      Generador de Etiquetas
    </template>
    <template #body>
      <div class="col-12 px-0">
        <InputProvider
          v-model="nueva_etiqueta.cantidad"
          label="Cantidad:"
          type="number"
          step="1"
          min="1"
          placeholder="Cantidad"
          :has-error="hasError(nueva_etiqueta.errors.cantidad)"
          :error-message="hasError(nueva_etiqueta.errors.cantidad) ? nueva_etiqueta.errors.cantidad[0] : ''"
          @keyup.enter="crearEtiquetas"
        />
      </div>
      <div class="col-sm-12 px-0">
        <ButtonProvider
          variant="primary"
          class="glow-on-hover w-100"
          @click="crearEtiquetas"
          label="Crear Etiquetas"
          icon="fa-magic jumping-icon"
        />
      </div>
      <div class="col-12 mt-4 px-0 text-left">
        <div class="row mx-0">
          <div class="col-12 px-0">
            <div class="invoice-table">
              <table class="table">
                <thead>
                  <tr>
                    <th style="font-size: 13px;">Etiquetas Creadas ({{ labels.length }})</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="detalle in labels" :key="detalle.id">
                    <td>{{ detalle.etiqueta }}</td>
                    <td class="text-right">
                      <ButtonProvider
                        variant="outline-dark"
                        size="sm"
                        @click="imprimir(detalle)"
                        icon="fa-print"
                      />
                      &nbsp;
                      <ButtonProvider
                        variant="outline-danger"
                        size="sm"
                        @click="eliminar(detalle)"
                        icon="fa-minus"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <ButtonProvider
            v-if="labels.length > 0"
            variant="dark"
            class="w-100"
            @click="imprimirAll"
            label="Imprimir Todas"
            icon="fa-print"
          />
        </div>
      </div>
    </template>
    <template #footer>
      <ButtonProvider
        variant="secondary"
        label="Cerrar"
        icon="fa-times"
        data-dismiss="modal"
      />
    </template>
  </ModalProvider>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import { 
  InputProvider,
  ModalProvider,
  ButtonProvider
} from "@/components/atomic";

export default {
  name: "RecepcionEtiquetaModalComponent",
  components: {
    InputProvider,
    ModalProvider,
    ButtonProvider
  },
  props: {
    recepcion: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      nueva_etiqueta: {
        cantidad: 1,
        errors: {
          cantidad: [],
        },
      },
    };
  },
  computed: {
    labels() {
      return this.recepcion.recepcionetiqueta_set || [];
    }
  },
  methods: {
    hasError(errorArray) {
      return errorArray && errorArray.length > 0;
    },
    imprimir(detalle) {
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?&report_name=wms/recepcion/etiqueta.jrxml&id=${detalle.id}`
      );
    },
    imprimirAll() {
      const id = this.recepcion.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?&report_name=wms/recepcion/etiqueta_all.jrxml&id=${id}`
      );
    },
    eliminar(detalle) {
      let self = this;
      let params = {
        etiqueta: detalle.etiqueta,
      };
      DynamicService.postAction(
        "wms",
        "recepcion",
        self.recepcion.id,
        "eliminar_etiqueta",
        params
      )
        .then((res) => {
          this.$emit("refresh", {});
        })
        .catch((error) => {
          if (error && error.response && error.response.data && error.response.data.detail) {
            alert(error.response.data.detail);
          }
        });
    },
    crearEtiquetas(e) {
      if (e && e.preventDefault) e.preventDefault();
      let self = this;
      let params = {
        cantidad: self.nueva_etiqueta.cantidad,
      };
      DynamicService.postAction(
        "wms",
        "recepcion",
        self.recepcion.id,
        "crear_etiqueta",
        params
      )
        .then((res) => {
          self.$emit("refresh", {});
          self.nueva_etiqueta = {
            cantidad: 1,
            errors: {
              cantidad: [],
            },
          };
        })
        .catch((error) => {
          if (error && error.response) {
            self.nueva_etiqueta.errors = error.response.data;
          }
        });
    },
  },
};
</script>
